import { Toast } from 'react-vant'

// Toast 自定义图标组件
const SuccessIcon = () => (
  <img src="/images/toast/success.svg" alt="success" className="w-5 h-5" />
)

const FailIcon = () => (
  <img src="/images/toast/error.svg" alt="error" className="w-5 h-5" />
)

const LoadingIcon = () => (
  <img src="/images/toast/loading.svg" alt="loading" className="w-5 h-5 animate-spin" />
)

const WarningIcon = () => (
  <img src="/images/toast/warning.svg" alt="warning" className="w-5 h-5" />
)

// 初始化 Toast 全局默认配置
export function initToastConfig() {
  // 设置全局默认配置
  Toast.setDefaultOptions({
    className: 'custom-toast',
    duration: 2000,
  })

  // 设置 success 类型默认配置
  Toast.setDefaultOptions('success', {
    icon: <SuccessIcon />,
    className: 'custom-toast',
  })

  // 设置 fail 类型默认配置
  Toast.setDefaultOptions('fail', {
    icon: <FailIcon />,
    className: 'custom-toast',
  })

  // 设置 loading 类型默认配置
  Toast.setDefaultOptions('loading', {
    icon: <LoadingIcon />,
    className: 'custom-toast',
    forbidClick: true,
    duration: 0,
  })
}

// 扩展 warning 类型（react-vant 没有内置）
export const ToastWarning = (message: string) => {
  return Toast({
    message,
    icon: <WarningIcon />,
    className: 'custom-toast',
  })
}

export default { initToastConfig, ToastWarning }

